import React from 'react';
import { useTheme } from 'styled-components';
import { Button } from '../../../components/Button/Button';
import {  Modal } from 'antd';
import { ReactComponent as FarmIcon } from '../../../assets/images/FarmIcon.svg';

/** Modal for converting an acre proposal to a field proposal. */
export const ConvertModal = (props: {
	open: boolean;
	onCancel: () => void;
	onConvert: () => void;
}) => 
{
	const theme = useTheme();


	return (
		<Modal
			open={props.open}
			onOk={props.onCancel}
			onCancel={props.onCancel}
			title={
				<div style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center'
				}}>
					<FarmIcon style={{ marginRight: 16 }}/>
					<div
						style={{
							fontSize: theme.fontSizes.large,
							fontWeight: 700,
							position: 'relative',
							top: 1
						}}
					>Convert to MaxScript Field Proposal?</div>
				</div>
			}
			className='ConvertModal'
			closable={true}
			footer={
				<div>
					<Button
						variant='outlined'
						style={{paddingLeft: 16, paddingRight: 16}}
						onClick={props.onCancel}
						className='cancelButton'
					>
						Cancel
					</Button>
					<Button
						variant='dark'
						style={{ marginLeft: 8, paddingLeft: 16, paddingRight: 16 }}
						onClick={props.onConvert}
						className='submitButton'
					>
						Convert
					</Button>
				</div>}
			centered
		>
			<div style={{ fontSize: theme.fontSizes.small }}>
				The following action will convert your current Acre Proposal into a Field Proposal. Units will be placed based on the field's predicted crop, expected yield, units ordered and rate specified.
			</div>
			<div style={{ fontSize: theme.fontSizes.small, marginTop: 8, fontWeight: theme.fontWeights.bold }}>
				<span style={{ fontStyle: 'italic' }}>NOTE: </span>Some fields may not be fully covered and treatments are not considered during the recommendation process, so please review your placements before ordering. 
			</div>
			<div style={{ fontWeight: theme.fontWeights.bold, marginTop: 8 }}>
				Do you wish to continue?
			</div>
		</Modal>
	);
};
